var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.to)?_c('router-link',{staticClass:"stat-card stat-card--link",attrs:{"to":_vm.to}},[_c('strong',[_vm._v(_vm._s(_vm.value))]),_c('span',[_vm._v(_vm._s(_vm.label))])]):_c('article',{staticClass:"stat-card"},[_c('strong',[_vm._v(_vm._s(_vm.value))]),_c('span',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }